export default {
  label: 'Transactions for',
  startDate: 'From',
  endDate: 'To',
  cancelButton: 'Cancel',
  applyButton: 'Apply',
};
